import { createFileRoute, Outlet } from '@tanstack/react-router';

/**
 * /finance layout (F-013) — a pure pass-through shell so finance views share one mounted layout
 * node and in-area navigation never tears the whole subtree down. Deliberately EMPTY: every view
 * keeps its own flag gate + FinanceGuard + FinanceNav (they differ per area — Tracking's sub-views
 * vs the dashboards board switcher). Lifting the nav up here is a follow-up, not this slice.
 */
export const Route = createFileRoute('/finance')({
  component: Outlet,
});
